import { render } from "./SingleAdsView.vue?vue&type=template&id=6a08adf1"
import script from "./SingleAdsView.vue?vue&type=script&lang=js"
export * from "./SingleAdsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__